import { PII_KINDS, type PiiKindKey } from "@sagot/constants";
import type { PrivacyOut } from "../../shared";

/** One switch per kind of personal data (Settings › Privacy › Redact before AI). */
export type Kinds = Record<PiiKindKey, boolean>;

/** A mask the server wrote into the preview, e.g. `[MOBILE]` (the capture group keeps it when splitting). */
export const MASK = /(\[[A-Z_]+\])/;

/** The saved switches; a kind the server does not list reads as off, as the server says. */
export const kindsOf = (privacy: PrivacyOut): Kinds =>
  Object.fromEntries(PII_KINDS.map((kind) => [kind, privacy.pii_redaction[kind] ?? false])) as Kinds;

/** Kinds switched on, in the console's display order. */
export const kindsOn = (kinds: Kinds): PiiKindKey[] => PII_KINDS.filter((kind) => kinds[kind]);

/** Whether the draft differs from what is saved. */
export const kindsChanged = (draft: Kinds, saved: Kinds): boolean => PII_KINDS.some((kind) => draft[kind] !== saved[kind]);

/** Splits preview text into plain parts and masks, in order (`isMask` marks the masks). */
export function maskParts(text: string): { text: string; isMask: boolean }[] {
  return text
    .split(MASK)
    .filter((part) => part !== "")
    .map((part) => ({ text: part, isMask: MASK.test(part) }));
}
